import templateUrl from 'servicestack/auto-query/auto-query-filter-selector.htm';
import basicController from 'servicestack/basic.controller.properties';

class controller {
    constructor() {
        const $ctrl = this;
        basicController($ctrl);
    }
    $onInit(){
        const $ctrl = this;
    }
}

const component  = {
    bindings: {
        filter: '<'
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default component;